import React, {Component} from 'react'
import { Row, Col, Button } from 'antd';
import { Breadcrumb, Card, Icon, notification, Layout, Upload } from 'antd'

const Dragger = Upload.Dragger;
const { Content } = Layout;
class PreRegistration extends Component {

  constructor(props) {
    super(props)
    this.state = {
      alertMessage: ""
    }
  }

  onUpload = (info) => {
    const status = info.file.status;
    if (status === 'done') {
      notification['success']({
        message: 'CSV file upload',
        description: 'File uploaded successfully',
      });
    } else if (status === 'error') {
      notification['error']({
        message: 'CSV file upload',
        description: 'Error processing the file',
      });
    }
  }

  renderNotes(){
  	return(
  		<div style={{fontSize: 16}}>
  			<h2 className="semibold"> Notes: </h2>
  			<ul>
	  		<li>These fields are mandatory for the consideration</li>
	  		<ul>
		  		<li>
					Employee company eMailid - In your own format like name@company.com witout any spaces before or after</li>
		 			<li>First name, Last name</li>
					<li>Mobile Number - Only the 10 digits without +91, Give only the personal mobile numbers not the office extentions</li>
					<li>Gender, Date of birth in DD-MM- YYYY like (06-06-1990)</li>
				</ul>
				<li>In cases of location please provide the location of the employee you would like to see on you corporate dashboard.</li>
				<li>Take care of duplication like <span className='semibold'>Banglore - Bengaluru, Gurugoan - Gurgaon, upper case and lower case - Delhi - delhi</span></li>
				<li>Please avoid lengthy locations like <span className='semibold'>Bengaluru building 12B </span>which can be modified to <span className='semibold'>Bglr  12B</span> for your own reference</li>
				<li>In case you have only one office in one city you can provide the location as the city name.</li>
				<li>In case you have multiple offices in the same city then you can provide the location name instead of city name</li>
				<li>Status field has entries of Add (In case of new employee) or Remove (In case the existing employee has left the organisation)</li>
  			</ul>
  		</div>
  	)
  }

  render() {
    return (
      <div>
        <Breadcrumb style={{paddingTop: 10, marginBottom: 20}}>
        	<Breadcrumb.Item><a href="/" style={{color: '#1890ff'}}>Home</a></Breadcrumb.Item>
        	<Breadcrumb.Item>Pre Registration</Breadcrumb.Item>
      	</Breadcrumb>
        <div>
        	<Card>
        		<h2 className="semibold"> Pre Registration </h2>
            <Row type="flex" justify="space-around" align="middle">
              <Col span={12}>
                    <h3> You can bulk register customers using CSV file </h3>
                    <p style={{marginBottom: 20}}>
                    	Download sample file and edit then upload
                    	<Button type='primary' size='large' style={{marginLeft: 20}} ghost><a style={{paddingLeft: 10, textDecoration: 'none'}} href="https://res.cloudinary.com/ekincare/raw/upload/v1538367777/sample_csvs/Pre-registration.csv"  download ><Icon type="download" theme="outlined" style={{paddingRight: 10}}/>Data Format File</a></Button>
                    </p>
                    <p style={{marginBottom: 20}}>
                    	Note: Customers will be created once the details are verified by our account managers.
                    </p>
                    <Dragger name="file"
                             action={window.API_URL + "corporate/customers/pre-register?company_id=" + sessionStorage.getItem('company_id')}
                             headers={{'x-ekincare-key': sessionStorage.getItem('axiosHeaders')}}
                             accept="text/csv"
                             onChange={this.onUpload}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">Click or drag CSV files here</p>
                    <p className="ant-upload-hint">Support for a single  upload. Strictly prohibit from uploading company data or other band files</p>
                  </Dragger>
                
              </Col>
            </Row>
            <br/>
            <br/>
            <Row type='flex' justify='center'>
            	{this.renderNotes()}
            </Row>
            </Card>
          </div>
      </div>);
  }

}

export default PreRegistration
